import { TemplateDTO } from '@app/src/view/Loading/template/dto/TemplateDTO';
import { TemplateModel } from '@app/src/view/Loading/template/model/TemplateModel';

export const hydrateTemplate = (data: TemplateDTO): TemplateModel => {
  const url = data.data.templateUrl;

  const dataHydrate: TemplateModel = {
    code: data.code,
    message: data.message,
    template: { url }
  };

  return dataHydrate;
};
